import myPic from 'assets/my_Pic.png'
import Typewriter from 'typewriter-effect'
import { Link } from 'react-router-dom'
import { useStateContext } from 'context/StateContext'
import { Helmet } from 'react-helmet-async'

export default function Hero() {
  const { handleButtonSound, handleButtonSound1 } = useStateContext()
  return (
    <>
      <Helmet>
        {/* <Helmet/> component is used to change title, description and tags for each pages. Normally ReactJS use just one "html" file so we can't change title 
        for each page. Helmet is an external library used to add this feature */}
        <meta charSet="utf-8" />
        <title>Steven Eric</title>
      </Helmet>
      <div className='px-2' id='hero-section' data-aos="fade-up">
        <div className="row ">
          <div className="col-12 col-lg-6 col-xl-7 d-flex align-items-center px-0 ">
            <div className="hero-inner px-4 px-sm-5 px-lg-4 px-xl-5 py-5">
              <h1>Hi, I'm Steven Eric</h1>
              <Typewriter
                options={{
                  strings: ['Web Developer', 'Creative Designer', 'Mobile App Developer'],
                  autoStart: true,
                  loop: true,
                  delay: 30,
                  deleteSpeed: 50,
                  wrapperClassName: "type-writer",
                  cursorClassName: "type-writer-cursor"
                }}
              />
              <p className='mt-4 mb-5'>
                I'm professional Web Developer & Web Designer based in US working on different projects. I can build awesome Designs with different programming languages.
              </p>
              {/* <a> tag is used for CV download to add CV in portfolio please add your CV in asset folder in .pdf or any format 
              and after import the file add in "href" and add and attribute "download" in a tag  */}
              <a className='btn btn-warning button-stylling me-3 py-2 px-3' onClick={handleButtonSound} href="#">Download CV</a>
              <Link className='btn btn-outline-info shadow py-2 px-3 second-button-stylling' to="/left_to_right/about" onClick={handleButtonSound1}>About Me</Link>
            </div>
          </div>
          <div className="col-12 col-lg-6 col-xl-5 ">
            <div className="absolute-layer"></div>
            <img src={myPic} alt="my picture" />
          </div>
        </div>
      </div >
    </>
  )
}
